import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

class BackOfficeUserDetailVehicleForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      errors: false,
      ownershipTypes: [],
      powerSupplies: []
    }
  }

  async componentWillMount () {
    try {
      this.setState({loading: true})
      let promises = [
        SostaOnlineApiService.fetchVehicleOwnershipTypes(),
        SostaOnlineApiService.fetchVehiclePowerSupplies()
      ]

      const result = await Promise.all(promises)

      if (result.filter(item => item.result !== 'ok').length > 0) {
        this.setState({errors: true, loading: false})
        return
      }

      this.setState({
        ownershipTypes: result[0].data,
        powerSupplies: result[1].data,
        loading: false
      })
    } catch (e) {
      this.setState({loading: false, errors: true})
    }
  }

  render () {
    const {error, handleSubmit} = this.props

    if (this.state.loading) {
      return (<div className="box">
        Caricamento in corso...
      </div>)
    }

    if (this.state.errors) {
      return (<div className="box text-danger">
        Errore nel caricamento dei dati...
      </div>)
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="box">
          <div className="row form-group">
            <div className="col-md-6 text-left">
              <label>Seleziona tipo Proprietà</label>
              <Field name="ownershipType" className="form-control" component="select" required>
                <option value="">Seleziona tipo di proprietà...</option>
                {this.state.ownershipTypes.map((item, index) => {
                  return (<option value={item.id} key={item.id + '-' + index}>
                    {item.name}
                  </option>)
                })}
              </Field>
            </div>

            <div className="col-md-6 text-left">
              <label>Seleziona Alimentazione Veicolo</label>
              <Field name="powerSupply" className="form-control" component="select" required>
                <option value="">Seleziona alimentazione veicolo...</option>
                {this.state.powerSupplies.map((item, index) => {
                  return (<option value={item.id} key={item.id + '-' + index}>
                    {item.name}
                  </option>)
                })}
              </Field>
            </div>

            <div className="col-md-6 text-left">
              <label>Targa</label>
              <Field component="input" name="plateNumber" type="text" className="resident-login" required/>
            </div>
          </div>
          {this.props.loading && <div className="well">Creazione Veicolo in Corso...</div> }

          {this.props.vehicleError && <div className="panel panel-danger">
            {this.props.vehicleError}
          </div>}

          {this.props.vehicleCreateSuccess && <div>
            <div className="row">
              <div className="col-md-4 col-md-offset-4 ">
                <div className="contrassegno">
                  <h4 className="contrassegno-h">Veicolo creato correttamente!</h4>
                </div>
              </div>
            </div>
          </div>}
          <p>
            <button type="submit" className="btn btn-lg btn-green">
              Crea Veicolo
            </button>
          </p>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'backofficeUserDetailVehicle'
})(BackOfficeUserDetailVehicleForm)


// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailVehicleForm.js